<div class="row">
    <div class="col-md-4 column-recipe" *ngFor="let item of videos">
        <div
                (click)="onViewVideo(item)"
                class="card-img-top animated fadeIn"
                [lazyLoad]="'https://img.youtube.com/vi/' + getYoutubeCode(item.youtube_link) + '/maxresdefault.jpg'">
            <div class="recipe-title">
                <span>{{ item.title }}</span>
            </div>
        </div>
    </div>
</div>

<button
        *ngIf="hasMore"
        type="button"
        class="btn btn-primary btn-icon-text load-more"
        (click)="loadMore()">
    <i class="ti-reload btn-icon-prepend"></i>
    {{ 'load_more' | localise }}
</button>
